import { LineChart } from '@mui/x-charts/LineChart';
import ChartCard from '../../analytics/ChartCard';
import { ResponseTimeDataPoint } from '../../../../types/admin';

interface ResponseTimeChartProps {
  data: ResponseTimeDataPoint[];
  loading?: boolean;
}

export default function ResponseTimeChart({ data, loading }: ResponseTimeChartProps) {
  const timestamps = data.map((d) => new Date(d.timestamp));
  const p50Data = data.map((d) => d.p50);
  const p95Data = data.map((d) => d.p95);
  const p99Data = data.map((d) => d.p99);

  return (
    <ChartCard title="API Response Time Percentiles" subtitle="Last 24 hours" loading={loading} height={400}>
      <LineChart
        xAxis={[
          {
            data: timestamps,
            scaleType: 'time',
            valueFormatter: (date) =>
              new Date(date).toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              }),
          },
        ]}
        yAxis={[
          {
            label: 'Response Time (ms)',
          },
        ]}
        series={[
          {
            data: p50Data,
            label: 'p50',
            color: '#2e7d32',
            showMark: false,
          },
          {
            data: p95Data,
            label: 'p95',
            color: '#ed6c02',
            showMark: false,
          },
          {
            data: p99Data,
            label: 'p99',
            color: '#d32f2f',
            showMark: false,
          },
        ]}
        grid={{ vertical: false, horizontal: true }}
        sx={{
          '& .MuiLineElement-root': {
            strokeWidth: 2,
          },
        }}
      />
    </ChartCard>
  );
}
